module.exports = "https://cdn.rsscc.cn/gtgjwap/Image/vipCard/checked.85bfa28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/auth/login/image/checked.jpg
// module id = sdgJ
// module chunks = 1